import { Component, OnInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { A2hsService } from 'src/app/services/a2hs.service';
import { AuthService } from 'src/app/services/auth.service';
import { InviteService } from 'src/app/services/modelService/invite.service';
import { VaniService } from 'src/app/services/vani.service';
import { AlertService } from 'src/app/util/alert.service';

@Component({
  standalone: false,
  selector: 'app-vani',
  templateUrl: './vani.component.html',
  styleUrls: ['./vani.component.scss'],
})
export class VaniComponent implements OnInit {

  constructor(public vani: VaniService, private a2hs: A2hsService,
    private alert: AlertService,
    private inviteService: InviteService,
    private actionSheetController: ActionSheetController, public auth: AuthService,
  ) { }

  ngOnInit() { }



  async intro() {
    this.vani.read("नमस्ते, मैं वाणी हूँ");

    let buttons = [{
      text: 'Video Tutorial',
      icon: 'logo-youtube',
      handler: () => {
        window.open('https://youtu.be/ITypKqtWo5g', '_blank')
      }
    }, {
      text: 'Ask anything',
      icon: 'chatbubble-ellipses',
      handler: () => {
        this.vani.read("यह सुविधा हम जल्द ही लॉन्च करेंगे")
      }
    }]
    if (this.auth.loggedInEmployee && this.auth.loggedInEmployee.id) {
      buttons.push({
        text: 'Invite',
        icon: 'share-social-outline',
        handler: () => {
          this.inviteService.createInvite()
        }
      }, {
        text: 'Info',
        icon: 'document-text-outline',
        handler: () => {
          this.showInfo();
        }
      }, {
        text: 'Install App',
        icon: 'phone-portrait-outline',
        handler: () => {
          this.a2hs.installPWA();
        }
      })
    }

    buttons.push(
      {
        text: 'Hide VANI',
        icon: 'woman',
        handler: () => {
          this.vani.read("आप सेटिंग्स से मुझे चालू या बंद कर सकते हैं")
          this.vani.show = false;
        }
      },
      {
        text: 'Cancel',
        icon: 'close',
        handler: () => {
          console.log('Cancel clicked');
        }
      })


    const actionSheet = await this.actionSheetController.create({
      header: 'VANI, Voice Assistance for Navigation Interface',
      buttons: buttons
    });

    await actionSheet.present();
  }

  async showMenu() {
    this.vani.read("नमस्ते, मैं वाणी हूँ");
    const actionSheet = await this.actionSheetController.create({
      header: 'Action Items',
      buttons: [{
        text: 'Invite',
        icon: 'share-social-outline',
        handler: () => {
          this.inviteService.createInvite()
        }
      }, {
        text: 'Info',
        icon: 'document-text-outline',
        handler: () => {
          this.showInfo();
        }
      }, {
        text: 'Install App',
        icon: 'phone-portrait-outline',
        handler: () => {
          this.a2hs.installPWA();
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });

    await actionSheet.present();
  }

  showInfo() {
    let message = "<b>👤 रिश्तेदार जोड़ें:</b><br>" +
      "किसी भी सदस्य को जोड़ने के लिए उसके नाम पर क्लिक करे, वह  सेलेक्ट हो जाएगा और फोटो पर क्लिक करने से उसकी पर्सनल डिटेल्स खुल जाएगी।<br><br>" +

      "<b>👴 दादाजी को जोड़ने के लिए:</b><br>" +
      "पिताजी के नाम पर क्लिक करें, फिर उनके पिता को जोड़ें।<br><br>" +

      "<b>👨‍👩‍👧 जीवनसाथी के परिवार को जोड़ने के लिए:</b><br>" +
      "जीवनसाथी के नाम पर क्लिक करें → उनके परिवार में जाएं → सास-ससुर, भाई-बहन को जोड़ें।<br><br>" +

      "<b>👵 ननिहाल जोड़ने के लिए:</b><br>" +
      "माता जी के नाम पर क्लिक करें → उनके परिवार को जोड़ें।<br><br>" +

      "<b>🗑️ Delete Option:</b><br>" +
      "गलत रिश्तेदार या संबंध हटाने के लिए फोटो पर क्लिक करें → Delete चुनें।<br><br>" +

      "<b>🔍 Join/Connect Option:</b><br>" +
      "रिश्तेदार जोड़ने से पहले Search करें – यदि पहले से बने हैं तो पूरा वंश जुड़ जाएगा।<br><br>" +

      "<b>🔁 डुप्लिकेट से बचें:</b><br>" +
      "किसी भी रिश्तेदार को जोड़ने से पहले Search करें।<br>" +
      "उदाहरण के लिए, अगर आपने अपने पिताजी को जोड़ा और आपके भाई ने भी बिना Search किए पिताजी को जोड़ा, फिर आपने भाई को Search करके जोड़ा, तो दो पिताजी दिखने लगेंगे – एक आपके और एक भाई के।<br><br>" +

      "<b>📌 ऐसे में:</b><br>" +
      "पिताजी की फोटो पर क्लिक करें → Merge चुनें → Duplicate entry चुनें → डिटेल्स Verify करें → Merge बटन पर क्लिक करें।<br><br>";
    this.alert.showAlert("🌳 सदस्य जोड़ने के लिए दिशा-निर्देश:", message, "OK", "");
  }
}
